import React from 'react';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem, GridRowModes } from '@mui/x-data-grid';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import tableBodyicon from '../../Assets/images/tablebody_edit.png';
import tableEditicon from '../../Assets/images/tableheader_edit.png';
import disabledEdit from '../../Assets/images/disabled_edit.png';
import { handleValidateCodevalue } from '../../Utility/constant';
import { PasswordViewCell, PasswordEditInputCell } from './PasswordCells';

export const getEmailConfigColumns = (options) => {        
    const { 
        rowModesModel, 
        handleEditClick, 
        handleSaveClick, 
        handleCancelClick, 
        internationalise,
        isIMap,
        canEdit = true 
    } = options;

    return [
        {
            field: 'actions',
            type: 'actions',
            headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <Tooltip title ={handleValidateCodevalue(internationalise,'COMMON_SAVE')}>
                            <GridActionsCellItem
                                icon={<CheckIcon />}
                                label= {handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                                onClick={handleSaveClick(id)}
                            />
                        </Tooltip>,
                        <Tooltip title ={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}>
                            <GridActionsCellItem
                                icon={<CancelIcon />}
                                label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                                onClick={handleCancelClick(id)}
                                color="inherit"
                            />
                        </Tooltip>,
                    ];
                }

                return [
                    <Tooltip title ={handleValidateCodevalue(internationalise,'COMMON_EDIT')}>
                        <GridActionsCellItem
                            icon={<img src={!canEdit ? disabledEdit : tableBodyicon} />}
                            label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                            onClick={handleEditClick(id)}     
                            color="inherit"
                            disabled={!canEdit}
                        />
                    </Tooltip>,
                ];
            },
        },
        ...(isIMap ? [
        {
            field : "imapHost",
            headerName: handleValidateCodevalue(internationalise,'PROF_IMAP_HOST'),
            flex: 1,
            editable: true,
            valueParser: (value) => value ? value.toString().trim() : value,
        },
        {
            field : "imapPort",
            headerName: handleValidateCodevalue(internationalise,'PROF_IMAP_PORT'),
            flex: 1,
            editable: true,
            valueParser: (value) => value ? value.toString().trim() : value,
        },
    ] :
        [{
            field : "smtpHost",
            headerName: handleValidateCodevalue(internationalise,'PROF_SMTP_HOST'),
            flex: 1,
            editable: true,
            valueParser: (value) => value ? value.toString().trim() : value,
        },
        {
            field : "smtpPort",
            headerName: handleValidateCodevalue(internationalise,'PROF_SMTP_PORT'),
            flex: 1,
            editable: true,
            valueParser: (value) => value ? value.toString().trim() : value,
        }]
        ),
        {
            field : "smtpUsername",
            headerName: handleValidateCodevalue(internationalise,'PROF_SMTP_USERNAME'),
            flex: 1,
            editable: true,
            valueParser: (value) => value ? value.toString().trim() : value,
        },
        {
            field: "smtpPassword",
            headerName: handleValidateCodevalue(internationalise, 'PROF_SMTP_PASSWORD'),
            flex: 1,
            editable: true,
            renderCell: (params) => <PasswordViewCell {...params} canEdit={canEdit} />, 
            renderEditCell: (params) => <PasswordEditInputCell {...params} canEdit={canEdit} />,
        }
    ];
};
